import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../api/request';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/Info/DisplayError';
import Loading from '../../../../components/Info/Loading';
import { AuthenticationError } from '../../../GradeEntry/Loaders/CreateEvaluationGradeEntryBaseLoader';
import { getPostulants } from '../api';
import { StudentFilePostulantRequest } from '../types';

export const ITEMS_PER_PAGE = 10;

export interface StudentFileListLoaderProps {
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  StudentFilePostulantRequest,
  any,
  AuthenticationError | AxiosResultDefaultError
>();

export const useStudentFileListLoader = useFetch;

export default function StudentFileListLoader({
  children,
}: StudentFileListLoaderProps) {
  const request = useCallback(async (query: any) => {
    return getPostulants({
      ...query,
      page: query.page - 1,
      items_per_page: ITEMS_PER_PAGE,
    });
  }, []);

  return (
    <FetchProvider
      request={request}
      defaultQuery={{ page: 1, items_per_page: ITEMS_PER_PAGE }}
      fetchImmediately
    >
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return <Loading insideCard />;
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }
          return children;
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
